import { currencyFilter } from '@/vue/filters/currencyFilter';
import { dateFilter } from '@/vue/filters/dateFilter';
import { langFilter, langPluralFilter } from '@/vue/filters/langFilter';
import { maskFilter } from '@/vue/filters/maskFilter';
import { momentFilter } from '@/vue/filters/momentFilter';
import { numberFilter } from '@/vue/filters/numberFilter';
import { relativeTimeFilter } from '@/vue/filters/relativeTimeFilter';
import { suppressZeroFilter } from '@/vue/filters/suppressZeroFilter';
import { timeFilter } from '@/vue/filters/timeFilter';
import { truncateFilter } from '@/vue/filters/truncateFilter';
import { ucfirstFilter } from '@/vue/filters/ucfirstFilter';

// In Vue 3 filters no longer exist. One recommended replacement is to use
// globalProperties, which is only available in Vue 3.
// See: https://v3-migration.vuejs.org/breaking-changes/global-api.html#vue-prototype-replaced-by-config-globalproperties

// This file contains what we'd like to put in globalProperties when available. For now these
// are added as methods on the root Vue instance so that they become available in all templates.

export const globalMethods = {
    /**
     * Instead of {{ 'LANG_KEY' | filter }}
     * use {{ _('LANG_KEY') }}
     *
     * @type {(function(string, Object): string)}
     */
    l: langFilter,

    /**
     * {{ langPluralFilter(count, key) }}
     */
    langPluralFilter,

    /**
     * Instead of {{ 12.34 | currency }}
     * use {{ currencyFilter(12.34) }}
     *
     * @type {(function(Number, Number=): string)}
     */
    currencyFilter,

    /**
     * Instead of {{ someDate | date(true) }}
     * use {{ dateFilter(someDate, true) }}
     *
     * @type {(function(Date, boolean): string)}
     */
    dateFilter,

    /**
     * Converts a string of text to asterisks. 'hello' becomes '●●●●●'.
     * {{ maskFilter(someText) }}
     *
     * @type {(function(*): string|string)|*}
     */
    maskFilter,

    /**
     * Instead of {{ someTime | moment('h:mm A') }}
     * use {{ momentFilter(currentTime, 'h:mm A') }}
     *
     * @type {(function(Date|string, string): string)}
     */
    momentFilter,

    /**
     * Instead of {{ someNumber | number }}
     * use {{ numberFilter(someNumber) }}
     *
     * @type {(function(Number): string)}
     */
    numberFilter,

    /**
     * Instead of { someTime | relativeTime }}
     * use {{ relativeTimeFilter(someTime) }}
     *
     * @type {(function((Date|string)): string)}
     */
    relativeTimeFilter,

    /**
     * @type {function(any, function): string}
     */
    suppressZeroFilter,

    /**
     * Instead of {{ someTime | time(session.multiDay) }}
     * use {{ timeFilter(someTime) }}
     *
     * @type {(function(Date, boolean): string)}
     */
    timeFilter,

    /**
     * Instead of {{ someString | truncate(20) }}
     * use {{ truncateFilter(someString, 20) }}
     *
     * @type {(function(string, number, string): string)}
     */
    truncateFilter,

    /**
     * Instead of {{ someString | ucfirst }}
     * use {{ ucfirstFilter(someString) }}
     *
     * @type {(function(string): string)|*}
     */
    ucfirstFilter,
};

// Register global methods.
// These are mostly all methods that replicate what we used filters for before.
// See: https://chafikgharbi.com/vuejs-global-function/
export const GlobalMethodsPlugin = {
    /**
     * @param {Vue} vueApp
     */
    install(vueApp) {
        Object.assign(
            vueApp.config.globalProperties,
            globalMethods
        );
    },
};
